import { createFileRoute } from '@tanstack/react-router';
import { VaultPage } from '@/features/tenders';

/** The vault of administrative documents (certificates, insurance, CVs, references) with expiry dates. */
export const Route = createFileRoute('/_auth/o/$orgId/tenders/vault')({
  component: VaultRoute,
});

function VaultRoute() {
  const { orgId } = Route.useParams();
  return <VaultPage orgId={orgId} />;
}
